/** Saved as `time_to_first_signal` on submit. */
export type DoOrDumpTimeToFirstSignal = "asap" | "30d" | "60d" | "90d" | "6mp";

export const DO_OR_DUMP_TIME_TO_SIGNAL_OPTIONS: { id: DoOrDumpTimeToFirstSignal; label: string }[] = [
  { id: "asap", label: "ASAP" },
  { id: "30d", label: "30 days" },
  { id: "60d", label: "60 days" },
  { id: "90d", label: "90 days" },
  { id: "6mp", label: "6 months+" },
];

export function isDoOrDumpTimeToFirstSignal(s: string): s is DoOrDumpTimeToFirstSignal {
  return DO_OR_DUMP_TIME_TO_SIGNAL_OPTIONS.some((o) => o.id === s);
}
